// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toggle-switch {
    width: 50px;
    height: 25px;
    border-radius: 25px;
    border: none;
    background-color: #ddd;
    position: relative;
    transition: background-color 0.2s;
}

#toggle-switch::before {
    content: "";
    position: absolute;
    top: 2.5px;
    left: 2.5px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #777;
    transition: transform 0.2s;
}

#toggle-switch.active {
    background-color: #f18f3c;
}

#toggle-switch.active::before {
    transform: translateX(25px);
}

.visibleToggle {
    display: block !important;
}

#api {
    display: none;
}

.apiKeyCard {
    padding-left: 0 !important;
}

.centerChat {
    margin: 0 auto;
}

#toggle-ai-switch {
    width: 50px;
    height: 25px;
    border-radius: 25px;
    border: none;
    background-color: #ddd;
    position: relative;
    transition: background-color 0.2s;
}

#toggle-ai-switch::before {
    content: "";
    position: absolute;
    top: 2.5px;
    left: 2.5px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #777;
    transition: transform 0.2s;
}

#toggle-ai-switch.active {
    background-color: #f18f3c;
}

#toggle-ai-switch.active::before {
    transform: translateX(25px);
}

.flex {
    display: flex;
}
.justify-between {
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/toggle-button.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,8BAA8B;AAClC","sourcesContent":["#toggle-switch {\n    width: 50px;\n    height: 25px;\n    border-radius: 25px;\n    border: none;\n    background-color: #ddd;\n    position: relative;\n    transition: background-color 0.2s;\n}\n\n#toggle-switch::before {\n    content: \"\";\n    position: absolute;\n    top: 2.5px;\n    left: 2.5px;\n    width: 20px;\n    height: 20px;\n    border-radius: 20px;\n    background-color: #777;\n    transition: transform 0.2s;\n}\n\n#toggle-switch.active {\n    background-color: #f18f3c;\n}\n\n#toggle-switch.active::before {\n    transform: translateX(25px);\n}\n\n.visibleToggle {\n    display: block !important;\n}\n\n#api {\n    display: none;\n}\n\n.apiKeyCard {\n    padding-left: 0 !important;\n}\n\n.centerChat {\n    margin: 0 auto;\n}\n\n#toggle-ai-switch {\n    width: 50px;\n    height: 25px;\n    border-radius: 25px;\n    border: none;\n    background-color: #ddd;\n    position: relative;\n    transition: background-color 0.2s;\n}\n\n#toggle-ai-switch::before {\n    content: \"\";\n    position: absolute;\n    top: 2.5px;\n    left: 2.5px;\n    width: 20px;\n    height: 20px;\n    border-radius: 20px;\n    background-color: #777;\n    transition: transform 0.2s;\n}\n\n#toggle-ai-switch.active {\n    background-color: #f18f3c;\n}\n\n#toggle-ai-switch.active::before {\n    transform: translateX(25px);\n}\n\n.flex {\n    display: flex;\n}\n.justify-between {\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
